import {
  Directive,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

@Directive({
  selector: '[opsDebounceClick]',
  standalone: true,
})
export class DebounceClickDirective {
  @Input() debounceTime = 2000;
  @Output() debouncedClick = new EventEmitter<Event>();

  private isCooldown = false;

  constructor(private el: ElementRef<HTMLButtonElement>) {}

  @HostListener('click', ['$event'])
  handleClick(event: Event) {
    // console.log('Button clicked:', event);
    if (this.isCooldown) {
      event.stopImmediatePropagation();
      event.preventDefault();
      return;
    }

    this.startCooldown();
    this.debouncedClick.emit(event);
  }

  private startCooldown() {
    this.isCooldown = true;
    this.el.nativeElement.disabled = true;

    setTimeout(() => {
      this.isCooldown = false;
      this.el.nativeElement.disabled = false;
    }, this.debounceTime);
  }
}
